import React, { useEffect, useState } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { gstinValidator } from 'common/utils/validator';
import { getDefaultValue } from './formControl';
import { fetchGSTDetail, validateGstNumber } from 'common/services/http.service';
import { ORDER_STATUS } from 'home/view/upgrade-order/constants';
import ShippingDetailsSummary from '../shippingDetails/summary';

const TitleComponent = React.memo(() => {
  return (
    <div className="upgrade-header-open">
      <div className="title pad-bottom-0">Billing Details</div>
      <label className="field_label">Confirm billing details for shifting order.</label>
    </div>
  );
});

const BillingDetailsSummary = ({ orderDetail }) => {
  const [form, setForm] = useState(() => getDefaultValue(orderDetail));

  const isGSTFieldEmpty = (value) => {
    if (value === '' || value === null) {
      setForm({ ...form, gstin: { value, touched: true, errors: [] } });
      return true;
    }
    return false;
  };
  const onGSTInChange = (value) => {
    value = value.trim().toUpperCase();
    if (gstinValidator(value)) {
      fetchGSTDetail(value).then(
        ({
          data: {
            result: { dty, sez }
          }
        }) => {
          let gstValue = form && form.gstin && form.gstin.value;
          if (gstValue !== value) {
            setForm({ ...form, gstin: { value, touched: true, errors: [] } });
          } else {
            setForm({ ...form, gstin: { value, touched: true, errors: [] } });
          }
        },
        (err) => {
          let errMsg = err && err.response && err.response.data && err.response.data.errorMsg;
          setForm({ ...form, gstin: { value, touched: true, errors: [errMsg ? errMsg : 'Please enter valid GSTIN'] } });
        }
      );
    } else {
      if (!isGSTFieldEmpty(value)) {
        setForm({ ...form, gstin: { value, touched: true, errors: ['Please enter valid GSTIN'] } });
      }
    }
  };

  const validateGSTIN = (value) => {
    value = value && value.trim().toUpperCase();
    if (gstinValidator(value)) {
      setForm({ ...form, gstin: { value, touched: true, errors: [] } });
      validateGstNumber(value).then(
        ({ data: { result } }) => {
          onGSTInChange(value);
        },
        (err) => {
          let errMsg = err && err.response && err.response.data && err.response.data.errorMsg;
          setForm({ ...form, gstin: { value, touched: true, errors: [errMsg ? errMsg : 'Please enter valid GSTIN'] } });
        }
      );
    } else {
      if (!isGSTFieldEmpty(value)) {
        setForm({ ...form, gstin: { value, touched: true, errors: ['Please enter valid GSTIN'] } });
      }
    }
  };

  useEffect(() => {
    setForm((prev) => {
      const form = getDefaultValue(orderDetail);
      if (form && form.gstin && form.gstin.value) {
        validateGSTIN(form.gstin.value);
      }
      return { ...form };
    });
  }, [orderDetail]);

  return (
    <div className="upgrade-accordion" style={{ marginBottom: 24 }}>
      <Accordion autoScrollOnExpand={false} title={<TitleComponent />} isExpanded={true} variant="round">
        <div className="accordion_body">
          <div className="form_area">
            <div className="devider_group">
              <div className="form_area">
                <h6>Billing Details</h6>
                <React.Fragment>
                  <div className="row">
                    <div className="flg-lg-12">
                      <div className="input_with_loader">
                        <Input label="GST Details" value={form.gstin.value} touched maxlength={15} disabled />
                      </div>
                    </div>
                  </div>

                  <div className="row field_row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Billing Address Pin Code" maxlength={6} value={form.pinCode.value ? form.pinCode.value : ''} required touched disabled />
                    </div>
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Billing Address City" value={orderDetail?.billingAddress?.city} placeholder="City" required disabled />
                    </div>
                  </div>
                  <div className="row field_row">
                    <div className="flg-lg-12">
                      <TextArea label="Billing Address" maxlength={250} required value={form.address.value} touched disabled />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <small id="helpId" className="help-text-counter">
                        {(form.address.value && form.address.value.length) || 0} /250
                      </small>
                    </div>
                  </div>
                </React.Fragment>
              </div>
            </div>
          </div>

          <div className="form_area">
            <h6>Billing Contact Details</h6>
            <div className="row field_row">
              <div className="flg-lg-6 flg-md-6">
                <Input label="Contact Person Name" maxlength={150} required value={form.personName.value} touched disabled />
              </div>
              <div className="flg-lg-6 flg-md-6">
                <Input label="Contact Person Number" maxlength={10} required value={form.mobileNumber.value ? form.mobileNumber.value : ''} touched disabled />
              </div>
            </div>
            <div className="row field_row">
              <div className="flg-lg-6 flg-md-6">
                <Input label="Contact Person Email" required value={form.email.value} touched disabled />
              </div>
            </div>
          </div>
        </div>
        <ShippingDetailsSummary orderDetail={orderDetail} />
      </Accordion>
    </div>
  );
};

export default BillingDetailsSummary;
